const apiSaveEbukvaApplications = "/api/ebukva/application/";
export { apiSaveEbukvaApplications };